import { CSSThemeVariables } from '@common/styling/cssThemeVariables';
import CssBaseline from '@mui/material/CssBaseline';
import { ThemeProvider } from '@mui/system';
import * as Sentry from '@sentry/react';
// eslint-disable-next-line @basaldev/no-dayjs-import
import dayjs from 'dayjs';
// eslint-disable-next-line @basaldev/no-dayjs-import
import 'dayjs/locale/ja';
import React from 'react';
import { createRoot } from 'react-dom/client';
import { BrowserRouter } from 'react-router-dom';

import '@campaign/styling/index.css';

import { App } from '@campaign/App';
import { theme } from '@campaign/styling/theme';
import { ErrorBoundary } from '@campaign/view/components/ErrorBoundary';

dayjs.locale('ja');

const basename = import.meta.env.BASE_URL.replace(/\/$/, '');

const root = createRoot(document.getElementById('root') as HTMLElement);

function onCatchError(error: Error) {
  Sentry.withScope(function (scope) {
    scope.setLevel('fatal');
    Sentry.captureException(error);
  });
}

function render() {
  root.render(
    <React.StrictMode>
      <ThemeProvider theme={theme}>
        <CSSThemeVariables theme={theme} />
        <CssBaseline />
        <ErrorBoundary onCatchError={onCatchError}>
          <BrowserRouter basename={basename}>
            <App />
          </BrowserRouter>
        </ErrorBoundary>
      </ThemeProvider>
    </React.StrictMode>
  );
}

if (
  import.meta.env.PCC_CAMPAIGN_SENTRY_DSN &&
  import.meta.env.PCC_APP_ENVIRONMENT !== 'local'
) {
  Sentry.init({
    beforeSend(event) {
      if (event.request?.url?.includes('meiji.co.jp/user')) {
        return null;
      }
      return event;
    },
    dsn: import.meta.env.PCC_CAMPAIGN_SENTRY_DSN,
    environment: import.meta.env.PCC_APP_ENVIRONMENT,
    ignoreErrors: ['Non-Error promise rejection captured'],
    integrations: [Sentry.browserTracingIntegration()],
    release: import.meta.env.PCC_APP_VERSION,
    tracesSampleRate: 1.0,
  });
}

render();
